import { cn } from '@/core/lib/utils/cn'
import { dateService } from '@/core/services/date'
import { withReactHookForm } from '@/core/ui/forms/with-react-hook-form'
import { useTranslations } from 'next-intl'
import { forwardRef } from 'react'
import { getLangDir } from 'rtl-detect'
import EndDate from './end-date'
import { StartDate } from './start-date'
import { useTimeAdjustment } from './useTimeAdjustment'
import { calculateTime } from './utils'
type TimeAdjustmentProps = {
  start: Date
  end: Date
  step?: number
  className?: string
  name: string
  value: string
  onChange: (date: string) => void
}

const buttonBeforeClasses =
  'before:absolute before:-bottom-2 before:left-1/2 before:block before:h-4 before:w-4 before:-translate-x-1/2 before:bg-navy before:[clip-path:polygon(50%_100%,0_0,100%_0)]'

export const TimeAdjustment = forwardRef<HTMLDivElement, TimeAdjustmentProps>(
  ({ step = 1, start, end, name, className = '', value, onChange }, ref) => {
    const t = useTranslations()
    //TODO
    const dir = getLangDir('')
    const { buttonPosition, handleMouseDown, handleTouchStart, containerRef } =
      useTimeAdjustment({
        start,
        step,
        end,
        onChange: date => {
          onChange?.(date.toISOString())
        },
        value: new Date(value),
        dir,
      })
    const selectedTime = calculateTime(start, end, buttonPosition)
    const displayTime = dateService.timeToHI(selectedTime)

    return (
      <>
        <div
          className={`my-20 flex h-1 w-full rounded px-5 ${className}`}
          ref={ref}
        >
          <span
            className='bg-pale-blue bg-opacity-25 relative h-1 w-4/5 rounded'
            ref={containerRef}
          >
            <StartDate time={dateService.timeToHI(start)} />
            <button
              type='button'
              className={cn(
                'bg-navy absolute -top-7 flex h-8 w-8 -translate-y-1/2 cursor-pointer items-center justify-center rounded-full p-1',
                buttonBeforeClasses,
              )}
              onMouseDown={handleMouseDown}
              onTouchStart={handleTouchStart}
              style={{
                left: dir === 'ltr' ? `${buttonPosition}%` : 'auto',
                right: dir === 'rtl' ? `${buttonPosition}%` : 'auto',
              }}
            >
              <span className='bg-slider-controller absolute top-1/2 left-1/2 z-20 h-full w-full -translate-1/2 bg-center bg-no-repeat text-white'></span>
              <p className='absolute bottom-full mb-1 flex w-max -translate-x-1/2 flex-col items-start ltr:left-1/2'>
                <span className='text-grey-50 font-medium'>
                  {t('forms.pickup')}
                </span>
                <span className='font-medium'>{displayTime}</span>
              </p>
            </button>
          </span>
          <span className='bg-grey-30 relative h-1 w-1/5 rounded'>
            <EndDate
              time={dateService.timeToHI(dateService.addHours(selectedTime, 1))}
            />
          </span>
        </div>

        <input name={name} hidden value={value} onChange={() => {}} />
      </>
    )
  },
)

export const FormTimeAdjustment = withReactHookForm(TimeAdjustment)
